import { ChangeDetectionStrategy, Component, output, ViewEncapsulation } from '@angular/core';
import { RouterLink } from '@angular/router';
import { WhiteLabelCtaLocation } from '../../typings';

@Component({
  selector: 'wil-landing-hero',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './landing-hero.component.html',
  styleUrl: './landing-hero.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class LandingHeroComponent {
  public readonly ctaClicked = output<WhiteLabelCtaLocation>();
}
